export default __webpack_public_path__ + "static/media/Landing Page Logo Grouping.ca42181d.png";